import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors, fonts } from '../../../global';

import { media } from '../../../services/media';

import { themeStyles } from '../../../services/themeStyles';
import { Navigation } from '../../Navigation';

const Pengestyrke = themeStyles(
    'pengestyrke',
    css`
        font-family: ${fonts.playfairDisplay};
        color: ${colors.white};
    `,
);

const Formue = themeStyles(
    'formue',
    css`
        font-size: 17px;
    `,
);

export const NavigationList = styled(Navigation)`
    display: block;

    width: 100%;
    padding: 0;

    margin: 0;

    list-style: none;

    ${media.min('lg')} {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-end;
        width: auto;
    }

    li {
        :not(:first-of-type) {
            margin: 0 0 0 30px;
        }
    }

    a,
    button {
        display: block;
        text-decoration: none;
        background: none;
        padding: 0;
        box-shadow: none;
        border: none;
        cursor: pointer;
        color: inherit;
        line-height: inherit;
        font-family: inherit;
    }

    ${Formue}
    ${Pengestyrke}
`;
